import { ReactNode } from "react";
import { Card } from "shared/components/Card";
import { cx } from "shared/utils";
import { useInboxEmbed } from "../context/useInboxEmbed";

const BUBBLE_MAX_WIDTH = 580;
const EMAIL_MAX_WIDTH = 900;
const CARD_PADDING = 24;
const CARD_BORDER = 1;
const CARD_CHROME = (CARD_PADDING + CARD_BORDER) * 2;
// Enough for the From/To lines, which an email narrower than them would
// otherwise wrap.
const EMAIL_MIN_WIDTH = 360;

interface MessageContentCardProps {
  isFromContact: boolean;
  children: ReactNode;
  className?: string;
  /** Canvas the email declares; the card sizes to it. 0 or absent if none. */
  contentWidth?: number;
}

export const MessageContentCard = ({
  isFromContact,
  children,
  className,
  contentWidth
}: MessageContentCardProps) => {
  // An iframe body is width:100%, which adds nothing to a shrink-to-fit box —
  // so left alone the card would size itself to the subject line instead.
  // The pop-up follows the design's bubble: 16px padding and a 16px radius, vs
  // the wider card /inbox has always drawn.
  const isCompact = Boolean(useInboxEmbed()?.compact);

  const emailWidth = contentWidth
    ? Math.min(
        Math.max(contentWidth + CARD_CHROME, EMAIL_MIN_WIDTH),
        EMAIL_MAX_WIDTH
      )
    : undefined;

  return (
    <Card
      className={cx(
        isCompact ? "rounded-2xl p-4" : "p-6",
        isFromContact ? "rounded-tl-none" : "rounded-tr-none",
        className
      )}
      style={{
        maxWidth: `min(${emailWidth ?? BUBBLE_MAX_WIDTH}px, 100%)`,
        width: emailWidth
      }}
    >
      {children}
    </Card>
  );
};
